import { Variants } from 'framer-motion';

const slideUpModal = {
  hidden: {
    y: '100vh',
  },
  visible: {
    y: '0',
    transition: {
      duration: 0.5,
      ease: [0, 0, 0, 1],
    },
  },
  exit: {
    y: '100vh',
    transition: {
      duration: 0.5,
      ease: [0, 0, 0, 1],
    },
  },
} as Variants;

const fadeIn = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: [0, 0, 0, 1],
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.5,
      ease: [0, 0, 0, 1],
    },
  },
} as Variants;

export type AnimationGroup =
  | Variants
  | readonly [Variants | undefined, null, Variants | undefined];

export const ANIMATIONS = {
  slideUpOnMobile: [slideUpModal, null, undefined],
  slideUp: slideUpModal,
  fadeInOnMobile: [fadeIn, null, undefined],
  fadeIn: [fadeIn, null, fadeIn],
} as const;
